import React, { useEffect } from 'react';
import { useHistory, useLocation } from 'react-router-dom';
import { useSelector, useDispatch } from 'react-redux';
import { FiArrowLeft, FiMenu } from 'react-icons/fi';
import { parseUrl } from 'query-string';
import { useQuery } from 'react-query';
import { OrdersCard } from '../../components';
import { OrderService } from '../../../support/services/api';
import { setSidebarVisible } from '../../../support/store/SidebarReducer';

import './styles.css';

function Orders() {
  const userData = useSelector((state) => state.AuthReducer.userData);
  const userId = useSelector((state) => state.AuthReducer.userId);
  const retrievedToken = useSelector((state) => state.AuthReducer.token);

  const { data: orders, isLoading, isIdle } = useQuery(['userOrders', userId],
    () => OrderService().getByUserId({ userId, token: retrievedToken }),
    {
      keepPreviousData: true,
      enabled: !!retrievedToken && !!userId,
      select: (res) => res.orders,
    });

  const history = useHistory();
  const location = useLocation();
  const dispatch = useDispatch();

  const onLogin = () => {
    history.push({
      pathname: '/login',
      state: { previousPath: location.pathname },
    });
  };

  const onMenu = () => {
    dispatch(setSidebarVisible({ visible: true }));
  };

  useEffect(() => {
    if (location.search) {
      const { query } = parseUrl(location.search);
      history.replace({ ...location, state: { nextPath: `/${query.nickname}` } });
    }
    if (!(retrievedToken && userId)) onLogin();
  }, []);

  if (!userData) return <></>;

  return (
    <div className="page-container">
      <section className="orders-header-container">
        <div className="options">
          <FiArrowLeft onClick={() => (location.state?.nextPath ? history.push(location.state.nextPath) : history.goBack())} className="touchable-icon" size={32} color="#000" />

          <p>
            Pedidos de
            {` ${userData.firstName} ${userData.lastName}`}
          </p>

          <FiMenu onClick={onMenu} size={32} color="#000" className="share-icon" />
        </div>
      </section>

      <section className="orders-container">
        {
          (isLoading || isIdle)
            ? <p className="no-orders-text">Carregando ...</p>
            : orders?.length
              ? orders.map((order) => (
                <OrdersCard key={order.id} order={order} />
              )).reverse()
              : (<p className="no-orders-text">Você não tem pedidos registrados</p>)
        }
      </section>
    </div>
  );
}

export default Orders;
